import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getActualUser } from '../services/users';
import { useEffect, useState } from 'react';
import User from '../models/user';

export interface IAuthRouteProps {
  component: any;
  path: string;
  exact?: boolean;
}

const PrivateRoute: React.FC<IAuthRouteProps> = ({
  component: Component,
  path,
  exact,
  ...rest
}) => {
  const [user, setUser] = useState({} as User);

  useEffect(() => {
    (async () => {
      setUser(await getActualUser());
    })();
  }, []);

  const authentication = () => {
    const currentLocation = window.location.pathname;
    if (user.is_admin) {
      return true;
    }
    if (
      currentLocation.includes('course') ||
      currentLocation.includes('profile') ||
      currentLocation.includes('exams-questions')
    ) {
      return true;
    } else return false;
  };
  return (
    <Route
      exact
      path={path}
      {...rest}
      render={props =>
        authentication() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/profile', state: { from: props.location } }}
          />
        )
      }
    />
  );
};

export { PrivateRoute };
